import Api from '.';

class PipeDealsApi extends Api {
  base_endpoint = 'persons';

  async findByEmail(email) {
    const result = await this.doRequest('get', `search`, { params: { term: email } });
    const data = result.data || {};
    const items = data.items || [];
    const first_item = items[0] || {};
    return first_item.item;
  }

  async create(person) {
    const result = await super.create(person);
    const data = result.data || {};
    return data;
  }
}

export default new PipeDealsApi();
